"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.get = function get(params, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);

  if (window && window.loggedUserIsAdmin != "1") {
    params.active = true
  }

  agendorAPI.get("/users", params, responseHandler);
};

module.exports.getById = function get(params, success, error) {
  var endpoint = "/users/" + params.id;
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.get(endpoint, params, responseHandler);
};

module.exports.getAll = function getAll(success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.get("/users", {}, responseHandler);
};



// WEBPACK FOOTER //
// ./app/util/api/users.js